import { Component } from '@angular/core';

@Component({
  selector: 'rt-stripe-powered-by',
  template: `<img src="assets/images/pricing/powered_by_stripe.svg" alt="" />`,
  standalone: true,
})
export class RtStripePoweredByComponent {}
